import React from "react";
import { Panel, PanelBody, PanelHeader } from "../components/panel/panel";
import CustomInput from "../components/formik/CustomInput";
import { useEffect } from "react";

const CSDForm = ({ formik, csd, setScd }) => {
  const handleFileUpload = (file, field) => {
  const reader = new FileReader();
  reader.onload = () => {
    formik.setFieldValue(field, reader.result.split(",")[1]); // base64
  };
  reader.readAsDataURL(file);
};

// useEffect(() => {
//   console.log("Formik values:  ", formik.values);
// }, [formik.values]);

  return (
    <Panel>
      <PanelHeader noButton={true}>
        Certificados de Sello Digital (CSD)
      </PanelHeader>
      <PanelBody>
        <div className="row">
          <CustomInput
            label="Clave privada"
            field="key"
            formik={formik}
            sm={4}
            type="file"
            accept=".key"
            required
            onChangeFile={(e) => {
              setScd({ ...csd, key: e });
              handleFileUpload(e, "b64Key");
            }}
          />
          <CustomInput
            label="Certificado publico"
            field="cer"
            formik={formik}
            sm={4}
            type="file"
            accept=".cer"
            //onChangeFile={(e) => setScd({ ...csd, cer: e })}
            onChangeFile={(e) => {
              setScd({ ...csd, cer: e });
              handleFileUpload(e, "b64Cer");
            }}

            required
          />
          <CustomInput
            label="Contraseña"
            field="csdPassword"
            formik={formik}
            sm={4}
            required
            type="password"
            autoComplete="new-password"
          />
        </div>
      </PanelBody>
    </Panel>
  );
};

export default CSDForm;